import TopTicker from "./components/TopTicker";
import Masthead from "./components/Masthead";
import CoverStory from "./components/CoverStory";
import IndexBoard from "./components/IndexBoard";
import Timeline from "./components/Timeline";
import Gallery from "./components/Gallery";
import FaqSection from "./components/FaqSection";
import Feedback from "./components/Feedback";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <TopTicker />
      <main className="w-full">
        <Masthead />
        <CoverStory />
        <IndexBoard />
        <Timeline />
        <Gallery />
        <FaqSection />
        <Feedback />
      </main>
      <SiteFooter />
    </div>
  );
}